var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator":_vm.breadcrumbSeparatorChar,"separator-class":_vm.breadcrumbSeparatorIconClass}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }